import { z } from 'zod';
import { TABS, isDay, isMonday } from './model';

/**
 * Search params of /o/$orgId/timesheets: `week` (a Monday, which the Friday reminder links to) and
 * `tab`. An invalid value is simply dropped.
 */
export const TimesheetsSearchSchema = z.object({
  week: z
    .string()
    .refine((value) => isDay(value) && isMonday(value))
    .optional()
    .catch(undefined),
  tab: z.enum(TABS).optional().catch(undefined),
});
export type TimesheetsSearch = z.infer<typeof TimesheetsSearchSchema>;
